"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListItemResponseFieldTextToJSON = exports.TemplateGalleryListItemResponseFieldTextFromJSONTyped = exports.TemplateGalleryListItemResponseFieldTextFromJSON = exports.instanceOfTemplateGalleryListItemResponseFieldText = exports.TemplateGalleryListItemResponseFieldTextValidationTypeEnum = exports.TemplateGalleryListItemResponseFieldTextFontColorEnum = exports.TemplateGalleryListItemResponseFieldTextFontFamilyEnum = exports.TemplateGalleryListItemResponseFieldTextTypeEnum = exports.attributeTypeMapTemplateGalleryListItemResponseFieldText = void 0;
var TemplateGalleryListItemResponseField_1 = require("./TemplateGalleryListItemResponseField");
exports.attributeTypeMapTemplateGalleryListItemResponseFieldText = [
    {
        name: "type",
        type: "string",
    },
    {
        name: "placeholder",
        type: "string",
    },
    {
        name: "lineHeight",
        type: "number",
    },
    {
        name: "fontFamily",
        type: "string",
    },
    {
        name: "fontSize",
        type: "number",
    },
    {
        name: "fontColor",
        type: "string",
    },
    {
        name: "fontWeight",
        type: "number",
    },
    {
        name: "value",
        type: "string",
    },
    {
        name: "validationType",
        type: "string",
    },
    {
        name: "validationCustomRegexFormatLabel",
        type: "string",
    },
    {
        name: "validationCustomRegex",
        type: "string",
    },
    {
        name: "masked",
        type: "boolean",
    },
    {
        name: "isEditableMergeField",
        type: "boolean",
    },
    {
        name: "originalFontSize",
        type: "number",
    },
    {
        name: "hidden",
        type: "boolean",
    },
    {
        name: "readOnly",
        type: "boolean",
    },
    {
        name: "lines",
        type: "string",
    },
];
/**
 * @export
 */
exports.TemplateGalleryListItemResponseFieldTextTypeEnum = {
    Text: "text",
};
/**
 * @export
 */
exports.TemplateGalleryListItemResponseFieldTextFontFamilyEnum = {
    Helvetica: "helvetica",
    Arial: "arial",
    Calibri: "calibri",
    Cambria: "cambria",
    Courier: "courier",
    Georgia: "georgia",
    Times: "times",
    Trebuchet: "trebuchet",
    Verdana: "verdana",
    NotoSerif: "notoSerif",
    NotoSans: "notoSans",
    Roboto: "roboto",
    RobotoMono: "robotoMono",
};
/**
 * @export
 */
exports.TemplateGalleryListItemResponseFieldTextFontColorEnum = {
    Black: "black",
    Blue: "blue",
    Red: "red",
    White: "white",
};
/**
 * @export
 */
exports.TemplateGalleryListItemResponseFieldTextValidationTypeEnum = {
    NumbersOnly: "numbers_only",
    EmailAddress: "email_address",
    LettersOnly: "letters_only",
    PhoneNumber: "phone_number",
    BankRoutingNumber: "bank_routing_number",
    BankAccountNumber: "bank_account_number",
    ZipCode: "zip_code",
    SocialSecurityNumber: "social_security_number",
    EmployerIdentificationNumber: "employer_identification_number",
    CustomRegex: "custom_regex",
};
/**
 * Check if a given object implements the TemplateGalleryListItemResponseFieldText interface.
 */
function instanceOfTemplateGalleryListItemResponseFieldText(value) {
    if (!("type" in value) || value["type"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListItemResponseFieldText = instanceOfTemplateGalleryListItemResponseFieldText;
function TemplateGalleryListItemResponseFieldTextFromJSON(json) {
    return TemplateGalleryListItemResponseFieldTextFromJSONTyped(json, false);
}
exports.TemplateGalleryListItemResponseFieldTextFromJSON = TemplateGalleryListItemResponseFieldTextFromJSON;
function TemplateGalleryListItemResponseFieldTextFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return __assign(__assign({}, (0, TemplateGalleryListItemResponseField_1.TemplateGalleryListItemResponseFieldFromJSONTyped)(json, ignoreDiscriminator)), { type: json["type"], placeholder: json["placeholder"] == null ? undefined : json["placeholder"], lineHeight: json["lineHeight"] == null ? undefined : json["lineHeight"], fontFamily: json["fontFamily"] == null ? undefined : json["fontFamily"], fontSize: json["fontSize"] == null ? undefined : json["fontSize"], fontColor: json["fontColor"] == null ? undefined : json["fontColor"], fontWeight: json["fontWeight"] == null ? undefined : json["fontWeight"], value: json["value"] == null ? undefined : json["value"], validationType: json["validationType"] == null ? undefined : json["validationType"], validationCustomRegexFormatLabel: json["validationCustomRegexFormatLabel"] == null
            ? undefined
            : json["validationCustomRegexFormatLabel"], validationCustomRegex: json["validationCustomRegex"] == null
            ? undefined
            : json["validationCustomRegex"], masked: json["masked"] == null ? undefined : json["masked"], isEditableMergeField: json["isEditableMergeField"] == null
            ? undefined
            : json["isEditableMergeField"], originalFontSize: json["originalFontSize"] == null ? undefined : json["originalFontSize"], hidden: json["hidden"] == null ? undefined : json["hidden"], readOnly: json["readOnly"] == null ? undefined : json["readOnly"], lines: json["lines"] == null ? undefined : json["lines"] });
}
exports.TemplateGalleryListItemResponseFieldTextFromJSONTyped = TemplateGalleryListItemResponseFieldTextFromJSONTyped;
function TemplateGalleryListItemResponseFieldTextToJSON(value) {
    if (value == null) {
        return value;
    }
    return __assign(__assign({}, (0, TemplateGalleryListItemResponseField_1.TemplateGalleryListItemResponseFieldToJSON)(value)), { type: value["type"], placeholder: value["placeholder"], lineHeight: value["lineHeight"], fontFamily: value["fontFamily"], fontSize: value["fontSize"], fontColor: value["fontColor"], fontWeight: value["fontWeight"], value: value["value"], validationType: value["validationType"], validationCustomRegexFormatLabel: value["validationCustomRegexFormatLabel"], validationCustomRegex: value["validationCustomRegex"], masked: value["masked"], isEditableMergeField: value["isEditableMergeField"], originalFontSize: value["originalFontSize"], hidden: value["hidden"], readOnly: value["readOnly"], lines: value["lines"] });
}
exports.TemplateGalleryListItemResponseFieldTextToJSON = TemplateGalleryListItemResponseFieldTextToJSON;
